module.exports = __webpack_public_path__ + "img/30.e3584130.gif";